import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDetails = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10 8C9.44772 8 9 8.44772 9 9C9 9.55228 9.44772 10 10 10H14C14.5523 10 15 9.55228 15 9C15 8.44772 14.5523 8 14 8H10Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 11C5 8.17157 5 6.75736 5.87868 5.87868C6.75736 5 8.17157 5 11 5H13C15.8284 5 17.2426 5 18.1213 5.87868C19 6.75736 19 8.17157 19 11V13C19 15.8284 19 17.2426 18.1213 18.1213C17.2426 19 15.8284 19 13 19H11C8.17157 19 6.75736 19 5.87868 18.1213C5 17.2426 5 15.8284 5 13V11ZM11 7H13C14.4708 7 15.3726 7.00425 16.0253 7.092C16.599 7.16913 16.6948 7.27883 16.7062 7.29185L16.7071 7.29289L16.7082 7.29383C16.7212 7.3052 16.8309 7.40098 16.908 7.97468C16.9958 8.62738 17 9.52925 17 11V13C17 14.4708 16.9958 15.3726 16.908 16.0253C16.8309 16.599 16.7212 16.6948 16.7082 16.7062L16.7071 16.7071L16.7062 16.7082C16.6948 16.7212 16.599 16.8309 16.0253 16.908C15.3726 16.9958 14.4708 17 13 17H11C9.52925 17 8.62738 16.9958 7.97468 16.908C7.40098 16.8309 7.3052 16.7212 7.29383 16.7082L7.29289 16.7071L7.29185 16.7062C7.27884 16.6948 7.16913 16.599 7.092 16.0253C7.00425 15.3726 7 14.4708 7 13V11C7 9.52925 7.00425 8.62738 7.092 7.97468C7.16913 7.40099 7.27883 7.3052 7.29185 7.29383L7.29289 7.29289L7.29383 7.29185C7.3052 7.27883 7.40099 7.16913 7.97468 7.092C8.62738 7.00425 9.52925 7 11 7Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDetails);
export { ForwardRef as ReactComponent };
